import React, { useState } from 'react'
import { useNotify } from 'react-admin'
import { JsonToMjml } from 'easy-email-core'
import { saveAs } from 'file-saver'
import mjml from 'mjml-browser'

import { Dropdown } from './Dropdown'

const exportOptions = ['Export JSON', 'Export HTML', 'Export MJML']

const onExportJSON = (values, templateName, showError) => {
  try {
    const stringifyTemplate = JSON.stringify(values, null, 2)
    navigator.clipboard.writeText(stringifyTemplate)
    const fileName = templateName ? `${templateName}.json` : 'email-template.json'
    saveAs(new Blob([stringifyTemplate], { type: 'application/json' }), fileName)
  } catch (error) {
    showError('Failed to export JSON.')
  }
}

const onExportHTML = (values, mergeTags, templateName, showError) => {
  try {
    const mjmlString = JsonToMjml({
      data: values.content,
      mode: 'production',
      context: values.content,
      dataSource: mergeTags,
    })
    const html = mjml(mjmlString, {}).html
    navigator.clipboard.writeText(html)
    const fileName = templateName ? `${templateName}.html` : 'email-template.html'
    saveAs(new Blob([html], { type: 'text/html' }), fileName)
  } catch (error) {
    showError('Failed to export HTML.')
  }
}

const onExportMJML = (values, mergeTags, templateName, showError) => {
  try {
    const mjmlString = JsonToMjml({
      data: values.content,
      mode: 'production',
      context: values.content,
      dataSource: mergeTags,
    })
    const fileName = templateName ? `${templateName}.mjml` : 'email-template.mjml'
    navigator.clipboard.writeText(mjmlString)
    saveAs(new Blob([mjmlString], { type: 'text/mjml' }), fileName)
  } catch (error) {
    showError('Failed to export MJML.')
  }
}

export const ExportTemplateDropdown = ({ values, mergeTags, templateName = null }) => {
  const [errorMessage, setErrorMessage] = useState('')

  const notify = useNotify()

  const handleShowError = (message) => {
    setErrorMessage(message)
  }

  if (errorMessage) {
    notify(errorMessage, { type: 'error' })
  }

  const handleExport = (index) => {
    switch (index) {
      case 0:
        onExportJSON(values, templateName, handleShowError)
        break
      case 1:
        onExportHTML(values, mergeTags, templateName, handleShowError)
        break
      case 2:
        onExportMJML(values, mergeTags, templateName, handleShowError)
        break
      default:
        break
    }
  }

  return (
    <Dropdown
      options={exportOptions}
      onOptionSelect={handleExport}
      buttonLabel="Export Template"
    />
  )
}
